import Wrapper from "./style"
import logo from '../../assets/logo.svg'

export const Footer = props => {
    const year = new Date().getFullYear();

    return (
        <Wrapper>
            <a href="https://www.mckinsey.com/"><img className="logo" src={logo} alt="Mckinsey MSA" /></a>
            {/* <nav>
                <ul>
                    <li>Nav Item</li>
                    <li>Nav Item</li>
                    <li>Nav Item</li>
                    <li>Nav Item</li>
                    <li>Nav Item</li>
                </ul>
                <ul className="social-links">
                    <li><a href=""><img src={linkedIn} /></a></li>
                    <li><a href=""><img src={twitter} /></a></li>
                    <li><a href=""><img src={facebook} /></a></li>
                    <li><a href=""><img src={youtube} /></a></li>
                    <li><a href=""><img src={rss} /></a></li>
                    
                </ul>
            </nav> */}
            <div className="info">
                {/* <div>
                    <a href="https://www.mckinsey.com/industries/financial-services/how-we-help-clients/panorama">Panorama</a>
                    <a>Support</a>
                </div> */}
                {/* <p>
                    McKinsey Insights - Get our latest thinking<br />on your iPhone, iPad, or Android device. 
                </p> */}
                <p>
                    &copy; 1996-{year} McKinsey & Company
                </p>
            </div>
        </Wrapper>
    )
}